import { createCustomTheme } from '@domains/subscription/theme'
import { Button, Dialog, Stack, ThemeProvider, Typography } from '@mui/material'

interface DeleteTemplateDialogProps {
  template: {
    name: string
    externalName: string
  }
  open: boolean
  onClose: () => void
  onDelete: () => void
}

export const DeleteTemplateDialog = ({ open, onClose, onDelete, template }: DeleteTemplateDialogProps) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <ThemeProvider theme={createCustomTheme()}>
        <Stack
          sx={{
            gap: 3,
            padding: 3,
          }}
        >
          <Stack
            sx={{
              gap: 1,
            }}
          >
            <Typography variant="h2">{`Are you sure you want to delete "${template.externalName}"?`}</Typography>
            <Typography variant="p3Regular" color="textSecondary">
              This action cannot be undone. All data associated with this template will be permanently deleted.
            </Typography>
          </Stack>
          <Stack
            sx={{
              alignSelf: 'flex-end',
              flexDirection: 'row',
              gap: 2,
            }}
          >
            <Button size="medium" data-testid="cancel-button" variant="tertiary" onClick={onClose}>
              Cancel
            </Button>
            <Button size="medium" color="error" data-testid="confirm-delete-template" variant="contained" onClick={onDelete}>
              Delete {template.name}
            </Button>
          </Stack>
        </Stack>
      </ThemeProvider>
    </Dialog>
  )
}
